import { put } from 'redux-saga/effects';

import { logout } from 'store/auth/actions';

export function* handleAuthError(error: any) {
    const statusCode = error.response?.status;

    if (statusCode === 401) {
        yield put(logout());

        return true;
    }

    return false;
}
